<template>
    <!-- 对话框 -->
    <el-drawer title="调整签约类型" :visible.sync="show" :with-header="false" size="600px" destroy-on-close :before-close="closeDialog">
        <div style="width: 95%; margin: 20px">
            <h2>调整签约类型</h2>

            <div class="text">
                <span
                    >司机名称: <span style="margin-left: 5px">{{ driver_name }}</span>
                </span>

                <span
                    >电话: <span class="orange" style="margin-left: 5px">{{ driver_phone }}</span>
                </span>
            </div>
            <div>
                <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto">
                    <el-form-item label="司机签约类型：" label-width="120px">
                        <el-radio-group v-model="submit_data.signing_type" :placeholder="submit_rules.signing_type.placeholder">
                            <el-radio label="0">兼职（按天）</el-radio>
                            <el-radio label="1">全职（按月）</el-radio>
                            <el-radio label="2">按单</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-button @click="addData" style="margin-left: 200px" type="primary">确定修改</el-button>
                </el-form>
            </div>
        </div>
    </el-drawer>
</template>

<script>
var _this;

import bus from '../../common/bus.js';
export default {
    props: {
        isShow: Boolean,
        data: '',
        driverName: '',
        driverPhone: '',
        driver_or_legwork: '',
        signing_type: ''
    },

    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.driver_name = _this.driverName;

            _this.driver_phone = _this.driverPhone;

            _this.submit_data.driver_code = _this.data;
            _this.submit_data.signing_type = _this.signing_type;
            console.log(_this.submit_data.signing_type, ' _this.submit_data.signing_type');
        }
    },
    data() {
        return {
            driver_name: '',
            driver_phone: '',
            // 表单数据
            submit_data: {
                driver_code: '',
                signing_type: ''
            },

            submit_rules: {
                signing_type: {
                    placeholder: '签约类型',
                    rules: {
                        required: true,
                        message: '签约类型不能为空',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            },
            show: false
        };
    },
    created() {
        _this = this;
    },

    methods: {
        // 关闭方法
        closeDialog() {
            _this.show = false;
            for (const key in _this.submit_data) {
                _this.submit_data[key] = '';
            }
        },
        addData() {
            _this
                .$post('/driver/editSigningType', _this.submit_data, _this.submit_rules)
                .then((res) => {
                    _this.$message.success({
                        message: res.msg,
                        duration: 1500
                    });
                    _this.$emit('onSubmit');
                    _this.closeDialog();
                })
                .catch((err) => {
                    _this.$message.success({
                        message: res.msg,
                        duration: 1500
                    });
                });
        }
    }
};
</script>

<style scoped>
h2 {
    font-family: Microsoft YaHei;
    font-weight: 600;
    line-height: 21px;
    color: #222;
    font-size: 18px;
    margin-bottom: 20px;
}

.text {
    border-bottom: 1px solid rgb(238, 238, 238);
    padding-bottom: 10px;
    margin-bottom: 10px;
}

.text > span {
    margin-right: 10px;
}

.orange {
    color: rgb(255, 149, 11);
    font-weight: 600;
}
</style>
